import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'GESTAO_VM_GRUPO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function initForm(registro = {}) {
    return [
        initialize('gestaoVMGrupoForm', registro)
    ];
}

export function setFiltro(filtro = {}) {
    return {
        type: 'GESTAO_VM_GRUPO_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'GESTAO_VM_GRUPO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista(documentos) {
	return (dispatch, getState) => {
		
		dispatch(setAguardando(true));

    	axios.get(`${consts.API_URL}/gestaoVMGrupo`).then(resp => {
			dispatch({
		        type: 'GESTAO_VM_GRUPO_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
	return async (dispatch, getState) => {
		if (!registro.id) {
			await axios.post(`${consts.API_URL}/gestaoVMGrupo`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/gestaoVMGrupo`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
	};
}

export function alterarOrdem(lista) {
	return async (dispatch, getState) => {
		axios.put(`${consts.API_URL}/gestaoVMGrupo/ordenar`, {
			lista: lista,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function alterarValidaVencimentos(registro, evento) {
	return async (dispatch, getState) => {
		axios.put(`${consts.API_URL}/gestaoVMGrupo/validaVencimentos`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			if (evento) {
				evento();
			}
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function excluir(registro, evento) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/gestaoVMGrupo?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			axios.get(`${consts.API_URL}/gestaoVMGrupo`).then(resp => {
				dispatch(alterarOrdem(resp.data));
			});
			
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaTipo() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/gestaoVMGrupoTipo/listarselect`)
		.then(resp => {
			dispatch({
				type: 'GESTAO_VM_GRUPO_TIPO_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}
